import gql from 'graphql-tag'

// NOTE: be careful when replacing `gql` with `questionnaireGql` since this can break `recordAudienceChangedForIRSNotification` work. Double check if the `recordAudienceChangedForIRSNotification` is still working after the replacement.
// `...DraftAudienceMember` resolves from the global fragment registry (see
// src/apollo/apolloClient.ts) so it does not need to be interpolated here,
// matching updateAudienceMemberV2.
export const SET_GLOBAL_AUDIENCE_MEMBER_V2 = gql`
  mutation setGlobalAudienceMemberV2($input: SetGlobalAudienceMemberV2Input!) {
    recordAudienceChangedForIRSNotification @client(always: true)
    setGlobalAudienceMemberV2(input: $input) {
      ...DraftAudienceMember
    }
  }
`
